import React from 'react';
import DeleteObject from '../../../common/poppers/DeleteObject';
import NewBankAccountNumber from '../../bankaccountnumber/NewBankAccountNumber';
import NewRestrain from '../restrain/restrain/NewRestrain';
import EmployeeRow from './EmployeeRow';
import ModifyEmployee from './ModifyEmployee';
import GeneralDetails from '../../../common/poppers/GeneralDetails';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import FilterListIcon from '@material-ui/icons/FilterList';
import AddIcon from '@material-ui/icons/Add';
import CancelOutlinedIcon from '@material-ui/icons/CancelOutlined';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import TrendingUpIcon from '@material-ui/icons/TrendingUp';
import NewVacation from '../vacation/vacation/NewVacation';
import Vacations from './Vacations';
import SalaryRaise from './SalaryRaise';
import BeachAccessIcon from '@material-ui/icons/BeachAccess';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import NewAvailableVacation from '../vacation/availablevacation/NewAvailableVacation';
import SalaryHistory from './SalaryHistory';
import ActivateEmployee from './ActivateEmployee';
import EmployeeHistory from './EmployeeHistory';

export const employeeActionItems = [
    {
        dataDialog: "modify-dialog",
        title: "Módosít",
        width: "lg",
        dialogTitle: "Munkavállaló módosítása",
        icon: <EditIcon fontSize="small" color="primary" />,
        actionComponent: (props, close) => <ModifyEmployee {...props} close={close} />
    },
    {
        dataDialog: "active-dialog",
        title: "Aktiválás",
        dialogTitle: "Munkavállaló aktiválása",
        canShow: (row) => !row.employee.active,
        icon: <CheckCircleOutlineIcon fontSize="small" color="primary" />,
        actionComponent: (props, close) => <ActivateEmployee {...props} close={close} path={'/api/activateemployee'} comp={<EmployeeRow {...props} />} />
    },
    {
        dataDialog: "active-dialog",
        title: "Inaktiválás",
        dialogTitle: "Munkavállaló inaktiválása",
        canShow: (row) => row.employee.active,
        icon: <CancelOutlinedIcon fontSize="small" color="primary" />,
        actionComponent: (props, close) => <ActivateEmployee {...props} close={close} path={'/api/activateemployee'} inactivate={true} comp={<EmployeeRow {...props} />} />
    },
    {
        dataDialog: "details-dialog",
        title: "Részletek",
        width: "lg",
        dialogTitle: "Munkavállaló részletek",
        icon: <FilterListIcon fontSize="small" color="primary" />,
        actionComponent: (props, close) => <GeneralDetails {...props} close={close} />
    },
    {
        dataDialog: "employee-history-dialog",
        title: "Munkavállaló történet",
        dialogTitle: "Munkavállaló történet",
        canShow: (row) => row.employee.type === "FULL_TIME",
        icon: <FilterListIcon fontSize="small" color="primary" />,
        actionComponent: (props, close) => <EmployeeHistory  {...props} close={close} />
    },
    {
        mainMenu: "Hozzáadás",
        icon: <AddIcon fontSize="small" color="primary" />,
        canShow: (row) => row.employee.type === "FULL_TIME",
        subMenus: [
            {
                dataDialog: "new-restrain-dialog",
                title: "Letiltás",
                dialogTitle: "Letiltás hozzáadása",
                actionComponent: (props, close) => <NewRestrain {...props} close={close} />
            },
            {
                dataDialog: "new-bankaccount-dialog",
                title: "Bankszámlaszám",
                dialogTitle: "Bankszámlaszám hozzáadása",
                actionComponent: (props, close) => <NewBankAccountNumber {...props} close={close} />
            }
        ]
    },
    {
        mainMenu: "Fizetés",
        icon: <MonetizationOnIcon fontSize="small" color="primary" />,
        canShow: (row) => row.employee.type === "FULL_TIME",
        subMenus: [{
            dataDialog: "salary-raise-dialog",
            title: "Emelés",
            dialogTitle: "Fizetés emelés",
            icon: <TrendingUpIcon fontSize="small" color="primary" />,
            actionComponent: (props, close) => <SalaryRaise  {...props} close={close} />
        },
        {
            dataDialog: "salary-history-dialog",
            title: "Történet",
            dialogTitle: "Fizetés történet",
            icon: <FilterListIcon fontSize="small" color="primary" />,
            actionComponent: (props, close) => <SalaryHistory  {...props} close={close} />
        }]
    },
    {
        mainMenu: "Szabadság",
        icon: <BeachAccessIcon fontSize="small" color="primary" />,
        canShow: (row) => row.employee.type === "FULL_TIME",
        subMenus: [
            {
                dataDialog: "new-vacation-dialog",
                title: "Új",
                width: "md",
                dialogTitle: "Szabadság hozzáadása",
                icon: <AddIcon fontSize="small" color="primary" />,
                actionComponent: (props, close) => <NewVacation {...props} close={close} />
            },
            {
                dataDialog: "vacations-dialog",
                title: "Részletek",
                width: "md",
                dialogTitle: "Munkavállaló szabadságai",
                icon: <FilterListIcon fontSize="small" color="primary" />,
                actionComponent: (props, close) => <Vacations {...props} close={close} />
            },
            {
                dataDialog: "available-vacations-dialog",
                title: "Éves szabadság hozzáadása",
                dialogTitle: "Elérhető szabadsága",
                actionComponent: (props, close) => <NewAvailableVacation {...props} close={close} />
            }]
    },
    {
        divider: true,
    },
    {
        dataDialog: "delete-dialog",
        title: "Törlés",
        dialogTitle: "Munkavállaló törlése",
        icon: <DeleteIcon fontSize="small" color="primary" />,
        actionComponent: (props, close) => <DeleteObject {...props} close={close} path={'/api/employee'} comp={<EmployeeRow {...props} />} />
    },
]